import {
  CampaignStatusType,
  ExchangeType,
  SortField,
  SortDirection,
  SortState,
  ParticipationFilterType,
  RewardView,
} from "@/components/features/campaigns/types";
import type { RewardViewType } from "@/components/features/campaigns/types";
import { create } from "zustand";

export const CAMPAIGN_SEARCH_QUERY_MAX_LENGTH = 100;

interface FiltersState {
  sortState: SortState;
  selectedStatuses: CampaignStatusType[];
  selectedExchanges: ExchangeType[];
  selectedRules: string[];
  participationFilter: ParticipationFilterType | null;
  searchQuery: string;
  rewardView: RewardViewType;
  setSortState: (sortState: SortState) => void;
  toggleSortField: (field: SortField) => void;
  setSelectedStatuses: (statuses: CampaignStatusType[]) => void;
  setSelectedExchanges: (exchanges: ExchangeType[]) => void;
  setSelectedRules: (rules: string[]) => void;
  setParticipationFilter: (filter: ParticipationFilterType | null) => void;
  setSearchQuery: (query: string) => void;
  setRewardView: (view: RewardViewType) => void;
  resetFilters: () => void;
}

const DEFAULT_SORT_STATE: SortState = {
  field: "currentEpochReward",
  direction: "desc",
};

export const useFiltersStore = create<FiltersState>((set, get) => ({
  sortState: DEFAULT_SORT_STATE,
  selectedStatuses: [],
  selectedExchanges: [],
  selectedRules: [],
  participationFilter: null,
  searchQuery: "",
  rewardView: RewardView.PER_EPOCH,

  setSortState: (sortState) => set({ sortState }),

  toggleSortField: (field) => {
    const currentSort = get().sortState;
    const newDirection: SortDirection =
      currentSort.field === field && currentSort.direction === "desc" ? "asc" : "desc";

    set({
      sortState: {
        field,
        direction: newDirection,
      },
    });
  },

  setSelectedStatuses: (selectedStatuses) => set({ selectedStatuses }),
  setSelectedExchanges: (selectedExchanges) => set({ selectedExchanges }),
  setSelectedRules: (selectedRules) => set({ selectedRules }),
  setParticipationFilter: (participationFilter) => set({ participationFilter }),
  setSearchQuery: (searchQuery) => set({ searchQuery: searchQuery.slice(0, CAMPAIGN_SEARCH_QUERY_MAX_LENGTH) }),
  setRewardView: (rewardView) => set({ rewardView }),
  resetFilters: () =>
    set({
      sortState: DEFAULT_SORT_STATE,
      selectedStatuses: [],
      selectedExchanges: [],
      selectedRules: [],
      participationFilter: null,
      searchQuery: "",
      rewardView: RewardView.PER_EPOCH,
    }),
}));
